module.exports = __webpack_public_path__ + "img/slices.ca9fa2c4.svg";